"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const react_router_dom_1 = require("react-router-dom");
const react_router_dom_2 = require("react-router-dom");
const reduxHooks_1 = require("src/hooks/reduxHooks");
const thunk_1 = require("src/stores/applicationStore/auth/thunk");
const react_bootstrap_1 = require("react-bootstrap");
const AppFormGroup_1 = __importDefault(require("src/components/molecules/AppFormGroup"));
const Alert_1 = __importDefault(require("src/components/molecules/Alert"));
const AppHeader_1 = __importDefault(require("src/components/molecules/AppHeader"));
const Success_1 = __importDefault(require("src/components/svg/Success"));
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const Logo_1 = __importDefault(require("src/components/svg/Logo"));
const ForgetPage = () => {
    const dispatch = (0, reduxHooks_1.useAppDispatch)();
    const navigate = (0, react_router_dom_2.useNavigate)();
    const [errors, setErrors] = (0, react_1.useState)(null);
    const [success, setSuccess] = (0, react_1.useState)(false);
    const { handleSubmit, register } = (0, react_hook_form_1.useForm)();
    const onSubmit = (data) => {
        setErrors(null);
        dispatch((0, thunk_1.forgotThunk)(data, setErrors, setSuccess));
    };
    if (!success) {
        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text-center" }, { children: (0, jsx_runtime_1.jsx)(Logo_1.default, { size: "big" }) })), (0, jsx_runtime_1.jsx)(AppHeader_1.default, { title: i18n_1.default.t("Forgot password") }), (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Form, Object.assign({ className: "app-form", noValidate: true, onSubmit: handleSubmit(onSubmit) }, { children: [(0, jsx_runtime_1.jsx)(AppFormGroup_1.default, { error: errors === null || errors === void 0 ? void 0 : errors.email, label: i18n_1.default.t("Email"), register: register, registerName: "email", controlClassName: "form-control-lg" }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "app-form__footer app-form__footer-additional" }, { children: [(0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, Object.assign({ className: "btn-lg", type: "submit" }, { children: i18n_1.default.t("Restore") })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, Object.assign({ to: "/" }, { children: i18n_1.default.t("I remember the password") }))] }))] }))] }));
    }
    return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "w-75" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "mb-3 text-center" }, { children: (0, jsx_runtime_1.jsx)(Logo_1.default, { size: "big" }) })), (0, jsx_runtime_1.jsx)(Alert_1.default, { variant: "success", icon: (0, jsx_runtime_1.jsx)(Success_1.default, {}), title: i18n_1.default.t("Password sent to email"), description: i18n_1.default.t("Try log in again"), action: {
                        title: i18n_1.default.t("Log in"),
                        btn_class: "btn-ghost btn-success",
                        onClick: () => {
                            navigate("/");
                        },
                    } })] })) }));
};
exports.default = ForgetPage;
